module.exports = __webpack_public_path__ + "img/teacher_1.3c4fc6a5.png";